export default __webpack_public_path__ + "3f98b78614eed11af8ac0fcbb88e2b8e.svg";